import OperationDetailsComponent from "../components/all-operation-details.component";

export default function OperationDetailsPage() {
  return (
    <div>
      <OperationDetailsComponent />
    </div>
  );
}
